export default __webpack_public_path__ + "static/boost_margin-e6aa84517426cafe55a3c87644848c2d.png";